import NoteAndGuidance from "../Components/NoteAndGuidance";
import { NoteAndGuidancePropsTypes } from "../NoteAndGuidancePropsTypes";

export default function NoteAndGuidanceContainer({
  surveyAnswersInfo,
  handleNextPage,
}: NoteAndGuidancePropsTypes) {
  return (
    <NoteAndGuidance
      surveyAnswersInfo={surveyAnswersInfo}
      handleNextPage={handleNextPage}
    />
  );
}
